import { render, staticRenderFns } from "./ReviewSQLHarvester.vue?vue&type=template&id=173ecf0a&"
import script from "./ReviewSQLHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewSQLHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports